





































import { InputNumber } from 'element-ui'
import { Vue, Prop, Component } from 'vue-property-decorator'

import Booking from '@/models/booking'

@Component({
  components: {
    [InputNumber.name]: InputNumber,
  },
})
export default class PresetPaymentOption extends Vue {
  @Prop() booking!: Booking
  @Prop() depositsAmount!: number
  @Prop() amountToPay!: number
  @Prop() totalError!: string
}
